export const CHECKBOX_ICON_SIZE = 20;
export const CHECKBOX_BORDER_WIDTH = 1;
export const CHECKBOX_CHECK_ICON_SIZE = 14;

export const FORM_CONTROL_LABEL_BASE_SX = {
  margin: 0,
  width: 'fit-content',
  '&.Mui-disabled': {
    cursor: 'not-allowed',
  },
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: 'text.primary',
  },
};
